import React from 'react';
import { TabType, Project } from '../types';
import { EnablementTab } from './EnablementTab';
import { Interface } from './Interface';
import { Users } from './Users';
import { TasksTab } from './TasksTab';

interface TabContentProps {
  activeTab: TabType;
  project: Project;
  role?: Project['role'];
  previewReviewLevel?: number;
}

export const TabContent: React.FC<TabContentProps> = ({ activeTab, project, role, previewReviewLevel }) => {
  // placeholder renderer removed as unused

  const isAdmin = role === 'owner' || role === 'manager';
  
  // Keep all components mounted but control visibility to prevent re-initialization
  return (
    <>
      <div style={{ display: activeTab === 'interface' ? 'block' : 'none', height: '100%', padding: '1.5rem' }}>
        {isAdmin && <Interface project={project} previewReviewLevel={previewReviewLevel} />}
      </div>
      
      <div style={{ display: activeTab === 'tasks' ? 'block' : 'none', height: '100%', padding: '1.5rem' }}>
        {isAdmin && <TasksTab project={project} />}
      </div>
      
      <div style={{ display: activeTab === 'enablement' ? 'block' : 'none', height: '100%', padding: '1.5rem' }}>
        {isAdmin && <EnablementTab project={project} />}
      </div>
      
      <div style={{ display: activeTab === 'users' ? 'block' : 'none', height: '100%', padding: '1.5rem' }}>
        {isAdmin && <Users project={project} />}
      </div>
    </>
  );
};